import { useTranslationHelper } from '@shared/hooks/useTranslationsHelper';
import {
  MdcBox,
  MdcCard,
  MdcCardContent,
  MdcChip,
  MdcGrid,
  MdcIcon,
  MdcIconButton,
  MdcList,
  MdcListItem,
  MdcMenu,
  MdcMenuAnchor,
  MdcTypography
} from 'ids-wc/dist/react/components';
import styles from './IRISPaymentHistory.module.css';

import { ChipStatusColors, IRISPaymentHistoryItem } from './models/IRISPaymentHistoryDTO.model';
import { NO_VALUE_DASH } from '@shared/constants/no-value-dash';
import { useRef } from 'react';

interface IRIPaymentHisoryItemProps {
  payment: IRISPaymentHistoryItem;
  onSelect: (data: string) => void;
}

export const ListItemMobile = (props: IRIPaymentHisoryItemProps) => {
  const { t } = useTranslationHelper('IRISPaymentHistory');

  const menuRef = useRef<HTMLMdcMenuElement>(null);

  const { payment, onSelect } = props;

  const { debtorNo, amount, status, institution, paymentDate, type, rfcode } = payment;

  const toggleMenu = () => {
    if (menuRef.current) {
      menuRef.current.open();
    }
  };

  return (
    <MdcCard background="surface-1" className={styles['iris-payment-history-list-item']}>
      <MdcCardContent>
        <MdcGrid row>
          <MdcGrid col="flex">
            <MdcGrid row className={styles['iris-payment-history-list-item']}>
              <MdcGrid col="flex" alignSelf="center">
                <MdcTypography text={t('date')} textAlign="left" variant="body2" />
                <MdcTypography text={paymentDate} textAlign="left" variant="headline6" color="textPrimary" />
              </MdcGrid>
            </MdcGrid>

            <MdcGrid row className={styles['iris-payment-history-list-item']}>
              <MdcGrid col="flex" alignSelf="center">
                <MdcTypography text={t('status')} textAlign="left" variant="body2" />
                <MdcChip
                  label={status ? t(status) : NO_VALUE_DASH}
                  size="sm"
                  type="tag"
                  variant="filled"
                  color={ChipStatusColors[status]}
                />
              </MdcGrid>
            </MdcGrid>

            <MdcGrid row className={styles['iris-payment-history-list-item']}>
              <MdcGrid col="flex" alignSelf="center">
                <MdcTypography text={t('contributionType')} textAlign="left" variant="body2" />
                <MdcTypography text={t(type)} textAlign="left" variant="headline6" color="textPrimary" />
              </MdcGrid>
            </MdcGrid>

            <MdcGrid row className={styles['iris-payment-history-list-item']}>
              <MdcGrid col="flex" alignSelf="center">
                <MdcTypography text={t('institution')} textAlign="left" variant="body2" />
                <MdcTypography
                  text={institution.description}
                  textAlign="left"
                  variant="headline6"
                  color="textPrimary"
                />
              </MdcGrid>
            </MdcGrid>

            <MdcGrid row className={styles['iris-payment-history-list-item']}>
              <MdcGrid col="flex" alignSelf="center">
                <MdcTypography text={'RF'} textAlign="left" variant="body2" />
                <MdcBox display="flex" alignItems="center">
                  <MdcTypography
                    text={rfcode ? rfcode : NO_VALUE_DASH}
                    textAlign="left"
                    variant="headline6"
                    color="textPrimary"
                  />
                </MdcBox>
              </MdcGrid>
            </MdcGrid>

            <MdcGrid row className={styles['iris-payment-history-list-item']}>
              <MdcGrid col="flex" alignSelf="center">
                <MdcTypography text={t('paymentAmount')} textAlign="left" variant="body2" />
                <MdcBox display="flex" alignItems="center">
                  <MdcIcon size="xs" icon="currency-euro" color="secondary" />
                  <MdcTypography text={amount} textAlign="left" variant="headline6" color="textPrimary" />
                </MdcBox>
              </MdcGrid>
            </MdcGrid>
          </MdcGrid>

          {debtorNo && (
            <MdcGrid col="auto">
              <MdcMenuAnchor>
                <MdcIconButton
                  icon="more-vert"
                  color="textPrimary"
                  size="sm"
                  labelAria={t('amoNr')}
                  onClick={toggleMenu}
                />
                <MdcMenu ref={menuRef}>
                  <MdcList>
                    <MdcListItem text={t('checkAMONr')} onClick={() => onSelect(debtorNo)} />
                  </MdcList>
                </MdcMenu>
              </MdcMenuAnchor>
            </MdcGrid>
          )}
        </MdcGrid>
      </MdcCardContent>
    </MdcCard>
  );
};
